import { findClosestElementByClass } from "../helpers/dom/closest";
import { toggleBox } from "../toggleBox/toggleBox";
import { scrollToPosition } from "../helpers/dom/scroll";

export const approvals = {
	acceptAll: function (checkboxClassName, parentClassName, contentClassName) {
		const groupCheckbox = document.querySelectorAll(
			`.${checkboxClassName} input[type="checkbox"]`
		);

		if (!groupCheckbox) return;

		for (let i = 0; i < groupCheckbox.length; i++) {
			const parent = findClosestElementByClass(groupCheckbox[i], parentClassName);
			const content = parent.querySelector(`.${contentClassName}`);
			const checkboxes = content.querySelectorAll(
				'div:not(.totalCheck) > input[type="checkbox"]'
			);
			let checkboxes_checked = Array.from(checkboxes).filter(this.isChecked);
			// checkboxes = checkboxes.querySelectorAll('input[type="checkbox"]');

			for (let j = 0; j < checkboxes.length; j++) {
				checkboxes[j].addEventListener("click", () => {
					checkboxes_checked = Array.from(checkboxes).filter(this.isChecked);
					// console.log(checkboxes, checkboxes_checked);

					if (checkboxes.length === checkboxes_checked.length) {
						groupCheckbox[i].checked = true;
					} else {
						groupCheckbox[i].checked = false;
					}
				});
			}

			groupCheckbox[i].addEventListener("click", () => {
				if (groupCheckbox[i].checked) {
					this.setSubmitPosition(parent);
				}

				[].forEach.call(checkboxes, (checkbox) =>
					this.checkCheckbox(checkbox, groupCheckbox[i].checked)
				);
			});
		}
	},
	isChecked: function (checkbox) {
		return checkbox.checked;
	},
	checkCheckbox: function (checkbox, groupCheckboxState) {
		if (groupCheckboxState) {
			checkbox.checked = true;
			return;
		}
		checkbox.checked = false;
	},
	setSubmitPosition: function (content) {
		const submit = this.findSubmit(content);
		// FIXME:
		// scrollToPosition(submit, 55, 1000);
	},
	findSubmit: function (content) {
		return content.querySelector("[data-submit]");
	},
};
